module.exports = __webpack_public_path__ + "img/wx_infoTop_new.4eddb8db.png";